import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ReviewIO } from 'ggApp/shared/components/ReviewIO';
import { Translator } from 'ggApp/modules/translator';
import { getTranslation } from 'ggApp/utils/text';
import TrustBadgesList from './trust-badges';
import SslIcon from './images/ssl.svg';

import { CheckoutFooter, Wrap, TrustBadges, Copyright } from './styles';

export default class Footer extends PureComponent {
    render() {
        const { store } = this.context;
        const {
            activeStore: { code: storeCode },
        } = this.props;

        const list = [
            {
                title: getTranslation(store, 'CHECKOUT_BADGE_SSL_TITLE'),
                secondaryTitle: getTranslation(store, 'CHECKOUT_BADGE_SSL_SEC'),
                icon: SslIcon,
            },
        ];

        return (
            <CheckoutFooter>
                <Wrap>
                    <TrustBadges>
                        <TrustBadgesList list={list} />
                        <ReviewIO />
                    </TrustBadges>

                    <Copyright>
                        <Translator
                            tk="FOOTER_COPYRIGHTS"
                            withValues={{
                                copyrightYear: new Date().getFullYear(),
                                storeCode,
                            }}
                        />
                    </Copyright>
                </Wrap>
            </CheckoutFooter>
        );
    }
}

Footer.contextTypes = {
    store: PropTypes.shape({}),
};
